import React from "react";
import { Chart } from "react-chartjs-2";
import { PriceMatchingData } from "../../types/betfair/price-matching/price-matching-data";
import { Ball } from "../../types/entities/ball";
import { CricketEvent } from "../../types/entities/cricket-event";
import { EventType } from "../../types/enums/event-type";

interface Props {
  eventData: PriceMatchingData;
}

export default function PriceMatchingRunsLineChart({
  eventData,
}: Readonly<Props>): React.JSX.Element {
  const datasets = [];
  const betfairRunsLineData: number[] = [];
  const ereborWicketsData: number[] = [];
  const ereborBoundariesData: number[] = [];
  const ereborOtherData: number[] = [];
  const labels = [];
  const oddsTimeToIndexMap = new Map<number, number>();

  eventData.firstInningsBetfairRunsLineOdds.forEach((odds, index) => {
    labels.push(odds.time);
    oddsTimeToIndexMap.set(odds.time, index);
    betfairRunsLineData.push(odds.price);
    ereborWicketsData.push(null);
    ereborOtherData.push(null);
    ereborBoundariesData.push(null);
  });

  eventData.eventInfo.events
    .filter((event: CricketEvent) => event.eventType === EventType.BOWL)
    .map((event: CricketEvent) => event as Ball)
    .forEach((ball: Ball) => {
      const historicBetfairPrice = eventData.matchedPrices.get(
        ball.bowlId.value
      );
      if (historicBetfairPrice) {
        const index = oddsTimeToIndexMap.get(
          historicBetfairPrice.betfairMarketTime
        );
        if (ball.dismissal) {
          ereborWicketsData[index] = historicBetfairPrice.betfairPrice;
        } else if (ball.runs + ball.extras >= 4) {
          ereborBoundariesData[index] = historicBetfairPrice.betfairPrice;
        } else {
          ereborOtherData[index] = historicBetfairPrice.betfairPrice;
        }
      }
    });

  datasets.push({
    label: "Wickets",
    data: ereborWicketsData,
    backgroundColor: "#cc0000",
    borderColor: "#cc0000",
  });
  datasets.push({
    label: "Boundaries",
    data: ereborBoundariesData,
    backgroundColor: "#0000cc",
    borderColor: "#0000cc",
  });
  datasets.push({
    label: "Other Balls",
    data: ereborOtherData,
    backgroundColor: "#00cc00",
    borderColor: "#00cc00",
  });
  datasets.push({
    label: "Betfair Runs Line",
    data: betfairRunsLineData,
    backgroundColor: "#555555",
    borderColor: "#555555",
  });

  return (
    <div>
      <Chart
        type="line"
        height={200}
        width={800}
        options={{
          scales: {
            x: {
              type: "time",
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        }}
        data={{
          labels: labels,
          datasets: datasets,
        }}
      />
    </div>
  );
}
